import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg, str} from '@lit/localize';
import {when} from 'lit/directives/when.js';
import {navigator, router} from 'lit-element-router';
import Cookies from 'js-cookie';

import store from '../../store';

import style from '../../../../scss/requestToken.scss';
import {loginWithEmail, setLoginEmail} from '../../slices/accountSlice';
import {routeUrl} from '../../util/routeUrl';
import getRoutes from '../../routes';
import {navigateTo, showMessage} from '../../slices/statusSlice';
import arrowRight from '../../icons/arrowRight';

@customElement('arc-request-token')
export class RequestToken extends connect(store)(router(navigator(LitElement))) {
	static styles = [style];

	emailForRequest = '';
	devLoginToken = null;

	constructor() {
		super();

		store.subscribe(() => this.requestUpdate());
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.route = route;
		this.params = params;
		this.query = query;
	}

	stateChanged(state) {
		this.status = state.status;
		this.emailForRequest = state.account.data.loginEmail || '';
		this.accountData = state.account.data.account;
		this.accountStatus = state.account.status;

		this.devLoginToken = state.account.data.devLoginToken;
	}

	async connectedCallback() {
		super.connectedCallback();
		const email = Cookies.get('arc-email');
		if (email) {
			store.dispatch(setLoginEmail({loginEmail: email}));
		} else {
			store.dispatch(setLoginEmail({loginEmail: ''}));
		}
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	onEmailForRequestInput(value) {
		console.log('Email input changed:', value);
		store.dispatch(setLoginEmail({loginEmail: value}));
		// accountMiddleware will handle success/error
	}

	async onRequestEmail() {
		await store.dispatch(loginWithEmail({email: this.emailForRequest}));
	}
	async onSignUp() {
		store.dispatch(navigateTo({route: 'signup', params: this.params}));
	}

	render() {
		const state = store.getState();

		return html`
			<div class="requestToken">
				<h1 class="title">${msg('Request Code')}</h1>
				<p>${msg('request login code description')}</p>
				<arc-text-input
					title="${msg('E-Mail')}"
					placeholder="${msg('Enter Email')}"
					.value=${this.emailForRequest}
					@value-change=${(e) => this.onEmailForRequestInput(e.detail.value)}
				>
				</arc-text-input>

				<arc-button
					class="submitButton"
					@click=${this.onRequestEmail}
					title="${msg('Request Login Code')}"
					type="primary"
					showIcon="true"
					iconColor="ok"
					.additionalInfo="${false}"
				>
					${arrowRight}
				</arc-button>
				${when(
					!this.status.noSubscriptions,
					() => html`
						<arc-button
							@click=${this.onSignUp}
							title="${msg('Not account yet? Signup')}"
							type="secondary"
						>
							${arrowRight}
						</arc-button>
					`
				)}
			</div>
		`;
	}
}
